const MAX_MANIFEST_BYTES = 512 * 1024

/**
 * Truncates string to max byte size (UTF-8). Used for manifest size limit.
 */
export function truncateManifest(manifest: string): string {
  const bytes = new TextEncoder().encode(manifest)
  if (bytes.length <= MAX_MANIFEST_BYTES) return manifest
  return new TextDecoder().decode(bytes.slice(0, MAX_MANIFEST_BYTES))
}

/**
 * Returns true if the URL points to an HLS (.m3u8, .m3u) or DASH (.mpd) manifest.
 */
export function isHlsOrDashUrl(url: string): boolean {
  const u = url.toLowerCase()
  return u.includes('.m3u8') || u.includes('.m3u') || u.includes('.mpd')
}

/**
 * Strip URL from hash
 */
export function stripHashFromUrl(url?: string): string | undefined {
  if (!url) return url
  try {
    const parsed = new URL(url)
    parsed.hash = ''
    return parsed.toString()
  } catch (ignore) {
    return url
  }
}
